import { Component, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ModalService } from 'src/app/common/modal/modal.service';
import { APP_Constants } from 'src/app/app.constant';
import { EventEmitter } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { timer } from 'rxjs';
import { Modal } from 'src/app/common/modal/modal';


@Component({
    selector: 'app-progress-indicator-v2',
    templateUrl: './progress-indicator-v2.component.html',
    styleUrls: ['./progress-indicator-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgressIndicatorV2Component implements OnInit {

  @Input() uploadId;
  img_paths;
  @Output() enableButtonEmitter: EventEmitter<any> = new EventEmitter<any>();
  responseStatus: String;
  color: String = 'primary';
  mode: String = 'indeterminate';
  isLoading: boolean = false;
  ngOnInit() {

    this.statuses = ["Started", "In progress", "Complete"];
    this.img_paths = ["./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,810,24,24))", "./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,780,24,24))", "./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,750,24,24))"];
    this.orderStatus = this.statuses[0];
    this.index = 0;
    this.percentage = 0;
    this.count = this.statuses.length;
    this.dateArray = new Array<string>(this.count);
    for (let i = 0; i < this.count; i++)
      this.dateArray[i] = "";
    this.div = 100 / this.count;
    this.getCurrentTime();
    this.dateArray[0] = this.day + ', ' + this.time;
    this.getCurrentStatus();
  }

  // CP-5195 start-Get status label dynamically according to order creation progress
  getStatus(status){
    let label;
    if(status === 'Complete' && this.responseStatus === 'complete'){
      if (this.successRecords < this.totalRecords && this.successRecords > 0) {
        label = 'Partially complete';
      } else if (this.successRecords === 0) {
        label = 'Order creation failed';
      } else {
        label = status;
      } 
    } else {
      label = status;
    }
    return label;
  }
  // CP-5195 end

  getCurrentStatus() {
    this.isLoading = true;
    let url;
    if(localStorage.getItem('customerCode')=="JLR")
    {
       url = APP_Constants.JLR_FILE_STATUS + this.uploadId;
    }
    else
    {
      url = APP_Constants.COX_FILE_STATUS + this.uploadId;
      url += '?customerCode=' + localStorage.getItem('customerCode');
      url += '&userId=' + localStorage.getItem('userName') + '&action=uploadDoc';
    }
   var exp = timer(0, 10000).pipe(
      switchMap(() =>
        this.appService.makeHttpGetRequest(url))      
    ).subscribe(response => {
      this.isLoading = true;      
      this.responseData = response['data'];
      if (response['message'].statusCode == "SUCCESS") {
        this.isLoading = false;
        this.getDetails();

        if (this.responseData.businessObject.status == "complete") {
          console.log('emitted true complete');
          this.enableButtonEmitter.emit(true);
          clearInterval(this.intervalId);
          exp.unsubscribe();
        }
      }
    }, error => {
      console.log("error" + error);
      this.isLoading = false;      

      let modal = new Modal({
        action: false, name: 'orderUpload', title: 'Order upload status', description: error.message, actionButtonText: ''
      });
      this.modalService.createModalBox(modal, error.status);
    });
  
  }
  getDetails() {
    this.successRecords = this.responseData.businessObject.successRecords;
    this.totalRecords = this.responseData.businessObject.totalRecords;
    this.responseStatus = this.responseData.businessObject.status;
    if (this.orderStatus != this.responseData.businessObject.status) {
      this.percentage = 100;
      this.orderStatus = this.responseData.businessObject.status;
      this.percentage = 0;
      for (let i = 0; i < this.count; i++) {
        if (this.orderStatus == this.statuses[i].toLowerCase()) {
          this.index = i;
          // if (this.orderStatus == this.responseData.businessObject.status) {
          //   let year = this.responseData.businessObject.createdOn.slice(0, 4)
          //   let mon = this.responseData.businessObject.createdOn.slice(5, 7)
          //   let da = this.responseData.businessObject.createdOn.slice(8, 10)

          //   let t = this.responseData.businessObject.createdOn.slice(11, 16)
          //   let d = mon + '/' + da + '/' + year + ', ' + t;

          //   this.dateArray[i] = d;
          // }
        }
      }
    }
    else {
      this.percentage = this.responseData.businessObject.successRecords * 100 / this.responseData.businessObject.totalRecords;
    }
  }
  getCurrentTime() {
    this.today = new Date();

    var dd = String(this.today.getDate()).padStart(2, '0');
    var mm = String(this.today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = this.today.getFullYear();
    var hh = this.today.getHours();
    var min = this.today.getMinutes();

    this.day = mm + '/' + dd + '/' + yyyy;

    if (hh.toString().length == 1)
      hh = '0' + hh;
    if (hh.toString().length == 0)
      hh = '00';

    if (min.toString().length == 1)
      min = '0' + min;
    if (min.toString().length == 0)
      min = '00';

    this.time = hh + ':' + min;
  }

  onDestroy() {
    clearInterval(this.intervalId);
  }
  @Input() configData;

  statuses;
  div;
  count;
  orderStatus;
  index;
  statusData;
  percentage = 0;
  counter = 0;
  responseData;
  day;
  time;
  today;
  dateArray;
  successRecords = 0;
  totalRecords = 0;
  constructor(private appService: AppService, private modalService: ModalService) { }
  intervalId;

}


